<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">
		<role-select v-model="form.role" :label="$t('pages.userForm.role')" :lock="isLock" :selected-group="selectedGroup" />
		<clients-select v-if="needClient" v-model="form.client_id"/>
		<branches-select v-if="needBranch && form.client_id" :filters="{client_id:form.client_id}" v-model="form.branch_id"/>
		<smart-input :error-messages="inputErrors.name" :required="true" :label="$t('pages.userForm.firstName')" v-model="form.name"></smart-input>
		<smart-input :error-messages="inputErrors.last_name" :label="$t('pages.userForm.lastName')" v-model="form.last_name"></smart-input>
		<smart-input :error-messages="inputErrors.email" type="email" :required="true" :label="$t('attributes.email')" v-model="form.email"></smart-input>
		<v-switch
			v-if="!isNew"
			v-model="showPassword"
			:label="$t('attributes.changePassword')"
		></v-switch>
		<smart-input v-if="showPassword || isNew" minlength="6" name="password" ref="pass" :required="true" :error="inputErrors.password" type="password" :label="$t('pages.userForm.password')" v-model="form.password"/>
		<smart-input v-if="showPassword || isNew" minlength="6" :error="inputErrors.password" required type="password" :label="$t('pages.userForm.confirm_password')" v-model="form.password_confirmation"/>
		<div class="form-group">
			<v-btn type="submit" color="success">{{ $t('attributes.save')}}</v-btn>
		</div>
	</form>
</template>

<script>
	import UserModule from "src/store/modules/User.module";
	import FormView from "src/mixins/FormView";
	import RoleSelect from "dev/view/users/RoleSelect";
	import ClientsSelect from "dev/view/clients/ClientsSelect";
	import BranchesSelect from "dev/view/branches/BranchesSelect";
	import RoleManager, {types as rolesTypes} from "dev/helpers/RoleManager";

	export default {
		props: ["type"],
		name: "user-form",
		components: {BranchesSelect, ClientsSelect, RoleSelect},
		data () {
			return {
				showPassword: false,
				form: {
					name: null,
					role:null
				}
			};
		},
		mixins: [new FormView(UserModule, "user")],
		methods:{
			onError(){
				let error = Object.values(this.inputErrors).map(err => err);
				this.$notfication.error(error);
			}
		},
		computed: {
			selectedGroup(){
				if(this.type===rolesTypes.OFFICERS)
					return "clients";
				else
					return null;
			},
			isLock() {
				if(this.type===rolesTypes.SURVEYORS) {
					return true;
				}
				else {
					return false;
				}
			},
			auth() {
				return this.$store.state.AuthModule.user;
			},
			isNew () {
				return !this.user.id;
			},
			AuthIsClient() {
				return this.$store.getters.isClient;
			},
			needClient() {
				return (!this.AuthIsClient) && RoleManager.needClient(this.form.role);
			},
			needBranch() {
				return RoleManager.needBranch(this.form.role);
			}
		},
		created() {
			if (this.auth.client_id) {
				this.form.client_id = this.auth.client_id;
				this.form.branch_id = this.auth.branch_id;
			}
		}
	};
</script>

<style>

</style>
